import { Box } from "@mui/material";

interface TabLabelProps {
  label: string;
  count: number;
}

export const TabLabel = ({
  label,
  count,
}: TabLabelProps): React.JSX.Element => (
  <Box display="flex" alignItems="center" gap={1}>
    {label}
    {count > 0 && (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minWidth={20}
        height={20}
        px={0.5}
        borderRadius="50px"
        bgcolor="brandPrimary.main"
        color="brandPrimary.contrastText"
        fontSize="0.75rem"
      >
        {count}
      </Box>
    )}
  </Box>
);
